<template>
	<div>
		<!-- 轮播 -->
		<el-row class="item-carousel-box">
			<el-carousel :interval="5000" arrow="never" height="600px" class="item-carousel">
				<el-carousel-item>
					<el-row class="hw-carousel-item">
						<img src="../assets/banner612.png" style="width: 100%; height: 100%;"
							@click="$router.push({path:'/vote'})" />
						<el-button type="primary" class="establish"
							@click="$router.push({path:'/vote'})">一键创建</el-button>
					</el-row>
				</el-carousel-item>
				<!-- 				<el-carousel-item>
					<el-row class="hw-carousel-item">
						<img src="../assets/bannerTwo.jpg" style="width: 100%; height: 100%" />
						<el-button type="primary" class="establish"
							@click="$router.push({path:'/vote'})">创建活动</el-button>
					</el-row>
				</el-carousel-item>
				<el-carousel-item>
					<el-row class="hw-carousel-item">
						<img src="../assets/bannerThree.jpg" style="width: 100%; height: 100%" />
						<el-button type="primary" class="establish"
							@click="$router.push({path:'/vote'})">创建活动</el-button>
					</el-row>
				</el-carousel-item> -->
			</el-carousel>
		</el-row>

		<el-row class="box-item item-safe" type="flex" justify="space-around">
			<el-col class="safe">
				<label>安全性</label>
				<span>
					系统服务器依托阿里云强大的云计算和CDN加速等服务；自主研发加密通讯，防破解；自研加密算法，有效防止作弊。
				</span>
			</el-col>
			<el-col class="safe">
				<label>稳定性</label>
				<span>
					云服务器集群+云数据库大并发架构，带宽足，能够支持上亿级别高并发的大型活动稳定举行。
				</span>
			</el-col>
			<el-col class="safe">
				<label>超强防刷</label>
				<span>超强防刷票，可拦截90%以上的水军和机器刷票行为。</span>
			</el-col>
		</el-row>

		<!-- 安全、稳定、专业的微信投票平台 -->
		<el-row class="box-item item-secure">
			<label class="title">安全、稳定、专业的微信投票平台</label>
			<span class="text">
				多种投票类型，多种投票逻辑，自定义配置模板，各种场景模板随心选择刷票行为。
			</span>
			<!-- 轮播 -->
			<el-row class="major">
				<el-carousel :interval="5000" arrow="never" height="360px" indicator-position="outside"
					ref="hwCarousel">
					<el-carousel-item>
						<el-row class="hw-item-carousel" type="flex" justify="space-between">
							<div class="polymorphic">
								<label class="title"
									:style="{background: 'url('+require('../assets/FORM.png')+') no-repeat'}">多种投票类型</label>
								<span class="text">活动类型丰富，功能全面，操作简单</span>
								<i>
									<span>●</span>
									涵盖在线报名、图片和视频投票、多选或单选投票
								</i>
								<i>
									<span>●</span>
									几十套模版随心换、丰富的自定义配置、多种投票逻辑
								</i>
								<i>
									<span>●</span>
									快速创建、实时预览、现场大屏、批量添加选手
								</i>
							</div>
							<img src="../assets/dcjmbxz.png" />
						</el-row>
					</el-carousel-item>
					<el-carousel-item>
						<el-row class="hw-item-carousel" type="flex" justify="space-between">
							<div class="polymorphic">
								<label class="title"
									:style="{background: 'url('+require('../assets/FORMWORK.png')+') no-repeat'}">自定义配置模板</label>
								<span class="text">活动类型丰富，功能全面，操作简单</span>
								<i>
									<span>●</span>
									投票类型多样，界面元素丰富，功能满足企业多种需求
								</i>
								<i>
									<span>●</span>
									单选投票、多选投票、必选投票、固定次数、周期次数
								</i>
								<i>
									<span>●</span>
									自定义配置页面的轮播图、模板、主题色、背景音乐、选手边框、漂浮物、页面背景图
								</i>
							</div>
							<img :src="require('../assets/zdypzmb.png')" />
						</el-row>
					</el-carousel-item>
					<el-carousel-item>
						<el-row class="hw-item-carousel" type="flex" justify="space-between">
							<div class="polymorphic">
								<label class="title"
									:style="{background: 'url('+require('../assets/SELECT.png')+') no-repeat'}">多种场景模板选择</label>
								<span class="text">活动类型丰富，功能全面，操作简单</span>
								<i>
									<span>●</span>
									活动类型丰富，功能全面，操作简单
								</i>
								<i>
									<span>●</span>
									涵盖在线报名、图片和视频投票、多选或单选投票、几十套模版随心换、丰富的自定义配置、多种投票逻辑、快速创建、实时预览、现场大屏、批量添加选手
								</i>
							</div>
							<img src="../assets/dzlxtp.png" />
						</el-row>
					</el-carousel-item>
				</el-carousel>
				<!-- 左箭头 -->
				<div class="left" v-on:click="arrowClick('hwCarousel','left')">
					<i class="el-icon-arrow-left"></i>
				</div>
				<!-- 右箭头 -->
				<div class="right" v-on:click="arrowClick('hwCarousel','right')">
					<i class="el-icon-arrow-right"></i>
				</div>
			</el-row>
		</el-row>
		<!--核心优势-->
		<el-row class="grey-box">
			<el-row class="box-item item-secure">
				<label class="title">核心优势</label>
				<span class="text">
					专业微信投票平台，更懂安全、更懂客户，为客户提供优质服务
				</span>
				<ul class="kernel">
					<li>
						<img src="../assets/qwjs.png" />
						<label>全网加速</label>
						<span>阿里云CDN加速稳定，浏览速度快到想不到</span>
					</li>
					<li>
						<img src="../assets/mfcj.png" />
						<label>免费创建</label>
						<span>极简模式，3分钟即可 完成活动搭建</span>
					</li>
					<li>
						<img src="../assets/fzzb.png" />
						<label>防止作弊</label>
						<span>多重高级防刷+人工智能分析有效防止作弊</span>
					</li>
					<li>
						<img src="../assets/sjdc.png" />
						<label>数据导出</label>
						<span>结果数据可导出excel一目了然</span>
					</li>
					<li>
						<img src="../assets/ffmb.png" />
						<label>模板丰富</label>
						<span>多款模板可供选择，支持漂浮物、背景音乐、背景图片</span>
					</li>
					<li>
						<img src="../assets/spzc.png" />
						<label>视屏支持</label>
						<span>支持上传本地视频在线播放</span>
					</li>
					<li>
						<img src="../assets/ssyl.png" />
						<label>实时预览</label>
						<span>创建时整体效果预览更清晰操作</span>
					</li>
					<li>
						<img src="../assets/bxsl.png" />
						<label>不限数量</label>
						<span>创建活动不限、流量不限、人数不限</span>
					</li>
					<li>
						<img src="../assets/fzsz.png" />
						<label>分组设置</label>
						<span>可以设置不同选手分组报名，分组投票</span>
					</li>
					<li>
						<img src="../assets/dxdxtp.png" />
						<label>多选、单选投票</label>
						<span>支持单选投票，多选投票等自定义设置投票规则 </span>
					</li>
				</ul>
			</el-row>
		</el-row>
		<!--产品介绍-->
		<el-row class="box-item item-secure">
			<label class="title">产品介绍</label>

			<div class="productPresentation">
				<img src="../assets/cpjs.png" />
				<ul class="productPresentationBox">
					<li>
						<label>图文投票 <span>●</span></label>
						<div>以图片的方式来选手展示</div>
					</li>
					<li>
						<label><span>●</span>视频投票 </label>
						<div>以视频的方式来展示选手</div>
					</li>
					<li>
						<label>语音投票 <span>●</span></label>
						<div>以语音的方式来展示选手</div>
					</li>
					<li>
						<label><span>●</span>选择投票 </label>
						<div>单选、多选、必选投票</div>
					</li>
					<li>
						<label>多分组投票 <span>●</span></label>
						<div>选手可分成多个组，可设置 多个分组联合投票</div>
					</li>
					<li>
						<label><span>●</span>在线自主报名 </label>
						<div>选手可在线自主报名，主办方 只需后台审核即可</div>
					</li>
				</ul>
			</div>
		</el-row>

		<el-row class="createActivities" type="flex" justify="center" align="middle">
			<label>安全、稳定的一站式托管运营微信平台</label>
			<el-button type="primary" class="createButton" @click="jump">创建活动</el-button>
		</el-row>

		<el-row class="item-applicable">
			<el-row class="box-item">
				<label class="applicableScene">适用场景</label>
				<ul class="AppListBox">
					<li v-for="(item,index) in AppList" :key="index" v-on:click="setActiveItem(index)"
						:class="{ lisColor: isActive == index }">
						{{item.label}}
					</li>
				</ul>
				<!-- 轮播 -->
				<el-row class="hw-item-carousel">
					<el-carousel indicator-position="none" :interval="4000" arrow="never" ref="carousel" type="card"
						class="el-carousel-box" height="560px" v-on:change="setActiveItem">
						<el-carousel-item v-for="(item,index) in AppList" :key="'h'+index">
							<el-row class="productBox">
								<div class="frameBox">
									<el-row class="title">
										<img :src="require('../assets'+item.imgUrl.replace('../assets',''))" />
										{{item.label}}
									</el-row>
									<el-row class="text">{{item.text}}</el-row>
									<ul class="details" v-if="isActive==index">
										<li v-for="(val,i) in item.children" :key="'s'+i">
											<span>●</span>
											{{val}}
										</li>
									</ul>
								</div>
							</el-row>
						</el-carousel-item>
					</el-carousel>
					<!-- 左箭头 -->
					<div class="left" v-on:click="arrowClick('carousel','left')">
						<i class="el-icon-arrow-left"></i>
					</div>
					<!-- 右箭头 -->
					<div class="right" v-on:click="arrowClick('carousel','right')">
						<i class="el-icon-arrow-right"></i>
					</div>
				</el-row>
			</el-row>
		</el-row>
<!-- 		<div style="position: absolute;bottom: 10px; right: 50px;z-index: 9999;">
			<video src="https://file.17716.cn/Content/upload/0529.mp4" width="480" height="320"   controls   loop="loop"  autoplay="autoplay">
			</video>
		</div> -->
	</div>
</template>

<script>
	export default {
		metaInfo: {
			title: '和文投票-专业微信投票评选活动制作平台-视频投票小程序-免费创建投票评选', // set a title
			meta: [{ // set meta
					name: 'keywords',
					content: '和文投票,小程序投票,视频投票小程序,微信小程序投票,微信投票,微信投票平台,微信投票活动,免费创建微信投票,微信投票管理系统,公众号投票,第三方微信投票平台'
				},
				{
					name: 'description',
					content: '免费在线创建微信投票活动,和文投票小程序投票平台依靠强大的技术保障，为用户提供专业的微信投票在线创建流程,操作简单,配色丰富,各种案例任意挑选,免费的一站式服务,致力于提高用户品牌传播力,增强粉丝互动'
				}
			],
		},
		components: {},
		data() {
			return {
				isActive: 0,
				AppList: [{
						label: '视频展示',
						imgUrl: '../assets/spzs.png',
						text: '适用于企事业单位、各类社会团体举办或开展评选活动',
						children: ['短视频大赛', '微视频大赛', '宣传视频评选', '视频征集活动', '创意小视频']
					},
					{
						label: '单位评选',
						imgUrl: '../assets/spzs.png',
						text: '适用于企事业单位举办或开展评选活动',
						children: ['十佳青年', '道德模范', '好人评选', '公益评选', '十佳医护', '企业之星', '创业楷模', '服务之星']
					},
					{
						label: '萌娃评选',
						imgUrl: '../assets/spzs.png',
						text: '适用于商家、校园举办或开展评选活动',
						children: ['最萌宝贝', '最萌福娃', '快乐小天使', '才艺大赛', '台历宝宝', '童星海选', '人气代言', '潮童pk']
					},
					{
						label: '摄影大赛',
						imgUrl: '../assets/spzs.png',
						text: '适用于商家、社会团体举办或开展评选活动',
						children: ['摄影大赛', '婚纱摄影', '镜头下的河村', '手机摄影大赛', '航拍摄影评选', '知音掠影', '校园随拍等']
					}
				],
			}
		},
		mounted() {},
		methods: {
			jump() {
				window.location = '#/vote';
			},
			// 轮播指示器索引
			setActiveItem(index) {
				this.$refs.carousel.setActiveItem(index);
				this.isActive = index;
			},
			// 轮播左右按钮
			arrowClick(ref, val) {
				if (val === 'right') {
					this.$refs[ref].next();
				} else {
					this.$refs[ref].prev();
				}
			},
		},
		watch: {

		},
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/page/index.vue